import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

const listPercentageRecipes = () =>
  axios.get(`${API_URL}/api/recipes/percentage`, authHeaders()).then(r => r.data);

const getPercentageRecipe = (id) =>
  axios.get(`${API_URL}/api/recipes/percentage/${id}`, authHeaders()).then(r => r.data);

const createPercentageRecipe = (data) =>
  axios.post(`${API_URL}/api/recipes/percentage`, data, authHeaders()).then(r => r.data);

const updatePercentageRecipe = (id, data) =>
  axios.put(`${API_URL}/api/recipes/percentage/${id}`, data, authHeaders()).then(r => r.data);

const approvePercentageRecipe = (id) =>
  axios.post(`${API_URL}/api/recipes/percentage/${id}/approve`, {}, authHeaders()).then(r => r.data);

const deletePercentageRecipe = (id) =>
  axios.delete(`${API_URL}/api/recipes/percentage/${id}`, authHeaders()).then(r => r.data);

const executePercentageRecipe = (id, data) =>
  axios.post(`${API_URL}/api/recipes/percentage/${id}/execute`, data, authHeaders()).then(r => r.data);

const getPercentageRecipeExecutions = (id) =>
  axios.get(`${API_URL}/api/recipes/percentage/${id}/executions`, authHeaders()).then(r => r.data);

// ── Dough Recipes (Phase 2) ───────────────────────────────────────────────────

const listDoughRecipes = () =>
  axios.get(`${API_URL}/api/recipes/dough`, authHeaders()).then(r => r.data);

const getDoughRecipe = (id) =>
  axios.get(`${API_URL}/api/recipes/dough/${id}`, authHeaders()).then(r => r.data);

const createDoughRecipe = (data) =>
  axios.post(`${API_URL}/api/recipes/dough`, data, authHeaders()).then(r => r.data);

const updateDoughRecipe = (id, data) =>
  axios.put(`${API_URL}/api/recipes/dough/${id}`, data, authHeaders()).then(r => r.data);

const approveDoughRecipe = (id) =>
  axios.post(`${API_URL}/api/recipes/dough/${id}/approve`, {}, authHeaders()).then(r => r.data);

const deleteDoughRecipe = (id) =>
  axios.delete(`${API_URL}/api/recipes/dough/${id}`, authHeaders()).then(r => r.data);

const executeDoughRecipe = (id, data) =>
  axios.post(`${API_URL}/api/recipes/dough/${id}/execute`, data, authHeaders()).then(r => r.data);

const getDoughRecipeExecutions = (id) =>
  axios.get(`${API_URL}/api/recipes/dough/${id}/executions`, authHeaders()).then(r => r.data);

const recipeService = {
  listPercentageRecipes,
  getPercentageRecipe,
  createPercentageRecipe,
  updatePercentageRecipe,
  approvePercentageRecipe,
  deletePercentageRecipe,
  executePercentageRecipe,
  getPercentageRecipeExecutions,

  listDoughRecipes,
  getDoughRecipe,
  createDoughRecipe,
  updateDoughRecipe,
  approveDoughRecipe,
  deleteDoughRecipe,
  executeDoughRecipe,
  getDoughRecipeExecutions,
};

export default recipeService;
